import { AutoMap } from '@automapper/classes';
import { IsDateString, IsDefined, IsNotEmpty, IsNumber, IsString, IsUUID } from 'class-validator';

export class SiteConfigurationsDto {
  @AutoMap()
  @IsDefined()
  @IsNotEmpty()
  @IsUUID()
  id: string;

  @AutoMap()
  @IsNotEmpty()
  @IsString()
  displayLabel: string;

  @AutoMap()
  @IsString()
  status: string;

  @AutoMap()
  @IsNumber()
  soc: number;

  @AutoMap()
  @IsString()
  availabilty: string;

  @AutoMap()
  @IsString()
  type: string;

  @AutoMap()
  @IsString()
  oem: string;

  @AutoMap()
  @IsNumber()
  rack: number;

  @AutoMap()
  @IsNumber()
  batteries: number;

  @AutoMap()
  @IsNumber()
  powerCapacity: number;

  @AutoMap()
  @IsNumber()
  energyCapacity: number;

  @AutoMap()
  @IsNumber()
  currentPower: number;

  @AutoMap()
  @IsDateString()
  lastUpdatedDate: string;
}
